module.exports = __webpack_public_path__ + "img/4D.684304eb.png";